<mat-list disableRipple>
  <mat-list-item
    *ngFor="let item of items; trackBy: trackBy"
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
  >
    <sn-icon matListIcon [icon]="item.objectInfo.icon"></sn-icon>
    <span class="object-info-name">{{ item.objectInfo.name }}</span>
    <sn-action-list alwaysCollapse [items]="actions" [context]="item"></sn-action-list>
  </mat-list-item>
</mat-list>
